import Dexie, { type Table } from 'dexie';

export interface UploadOptions {
  autoCategorize?: boolean;
  generateSeo?: boolean;
  langCode?: string;
  /** Категории для wallpaper — future feature */
  category_assignments?: Array<{ category_id: number; is_primary: boolean }>;
  /** Автоматически запускать AI pipeline после upload. Default: true */
  auto_ai_pipeline?: boolean;
  /** Язык для AI pipeline. Default: 'pl' */
  lang_code?: string;
  /** Force-replace existing wallpaper at the resolved legacy id and re-run AI. Default: false */
  override?: boolean;
}

export interface UploadQueueRow {
  id: string;            // uuid
  file: Blob;            // original file
  fileName: string;
  fileSize: number;
  contentType: string;
  status: 'queued' | 'uploading' | 'processing' | 'done' | 'error' | 'paused';
  progress: number;       // 0..100
  retries: number;
  error?: string;
  options: UploadOptions;
  uploadedPath?: string;  // storage path on success
  /** ID wallpaper в БД, заполняется после успешной обработки */
  wallpaper_id?: number;
  createdAt: number;
  updatedAt: number;
}

// Keep legacy shape for backward-compat (T3 bootstrap had this)
export interface UploadQueueItem {
  id?: number;
  file: Blob;
  fileName: string;
  status: 'pending' | 'uploading' | 'done' | 'error';
  createdAt: Date;
  errorMessage?: string;
}

export interface AuthStoreItem {
  key: string;
  value: string;
}

export class WanderoAdminDB extends Dexie {
  uploadQueue!: Table<UploadQueueRow>;
  authStore!: Table<AuthStoreItem>;

  constructor() {
    super('wandero-admin');
    this.version(1).stores({
      // kept for migration continuity
      uploadQueue: '++id, status, createdAt',
    });
    this.version(2).stores({
      uploadQueue: '++id, status, createdAt',
      authStore: 'key',
    });
    this.version(3).stores({
      // Replace numeric PK with string uuid (T23)
      uploadQueue: 'id, status, createdAt',
      authStore: 'key',
    });
  }
}

// Singleton instance
export const db = new WanderoAdminDB();
